import React from 'react';
import { NavLink } from 'react-router-dom';
import { Calendar, LayoutDashboard, ReceiptText, User } from 'lucide-react';
import { NavItem } from '../interfaces/All';

const Footer: React.FC = () => {

  let navItems: NavItem[] = [
    {
      title: 'Dashboard',
      path: '/dashboard',
      icon: <LayoutDashboard size={20} />
    },
    {
      title: 'Wallet',
      path: '/ledger',
      icon: <ReceiptText size={20} />
    },
    {
      title: 'Lessons',
      path: '/lesson',
      icon: <Calendar size={20} />
    },
    {
      title: 'Students',
      path: '/students',
      icon: <User size={20} />
    },
  ];

  return (
    <footer className="fixed bottom-0 bg-transparent bg-opacity-30 backdrop-blur-lg left-0 right-0 h-16 bg-card border-t border-border md:hidden z-10">
      <div className={`grid grid-cols-${navItems.length} h-full`}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path|| '/'}
            className={({ isActive }) => `
              flex flex-col items-center justify-center transition-colors
              ${isActive
                ? 'text-primary'
                : 'text-text-light hover:text-text'
              }
            `}
            end={item.path === '/'} // Only exact match for home
          >
            {item.icon}
            <span className="text-xs mt-1">{item.title}</span>
          </NavLink>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
